import React, { useState } from 'react';
import MainNavbar from './components/MainNavbar';
import MainSidebar from './components/MainSidebar';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Home from './pages/Home';
import OrganizationForm from './pages/OrganizationForm';
import UserLoginForm from './pages/UserLoginForm';
import Dashboard from './pages/Dashboard';
import VendorForm from './pages/VendorForm';
import VendorList from './pages/VendorList';
import Report from './pages/Report';
import PRList from './pages/PRList';
import UserList from './pages/UserList';
import Solutions from './pages/Solutions';
import ContactUs from './pages/ContactUs';
// import UserForm from './pages/UserForm';
import UsersForm from './pages/UsersForm';
import GSTInvoice from './pages/GSTInvoice'
import Footer from './pages/Footer';

import './App.css';

function App() {
  const [loggedIn, setLoggedIn] = useState(localStorage.getItem('loggedIn') === 'true');
  const [currentPage, setCurrentPage] = useState(localStorage.getItem('currentPage') || 'Home');
  const [orgLoggedIn, setOrgLoggedIn] = useState(localStorage.getItem('orgLoggedIn') === 'true');

  const updateState = (page, logged, orgLogged) => {
    setCurrentPage(page);
    setLoggedIn(logged);
    setOrgLoggedIn(orgLogged);
    localStorage.setItem('loggedIn', logged);
    localStorage.setItem('orgLoggedIn', orgLogged);
    localStorage.setItem('currentPage', page);
  };

  const handleOrgLogin = () => updateState('UserList', true, true);
  const handleUserLogin = () => updateState('Dashboard', true, false);
  const handleLogout = () => updateState('Home', false, false);

  const renderNavbar = () => {
    if (orgLoggedIn) return <MainNavbar handleLogout={handleLogout} />;
    if (loggedIn) return <Navbar setCurrentPage={setCurrentPage} handleLogout={handleLogout} />;
    return <MainNavbar handleLogout={handleLogout} />;
  };


  const renderSidebar = () => {
    if (orgLoggedIn) return <MainSidebar setCurrentPage={setCurrentPage} currentPage={currentPage} />;
    if (loggedIn) return <Sidebar setCurrentPage={setCurrentPage} currentPage={currentPage} />;
    return <MainSidebar setCurrentPage={setCurrentPage} currentPage={currentPage} />;
  };
  

  const pageRoutes = {
    Home: <Home setCurrentPage={setCurrentPage} />,
    OrganizationForm: (
      <OrganizationForm setIsLoggedIn={handleOrgLogin} setCurrentPage={setCurrentPage} />
    ),
    UserLoginForm:( <UserLoginForm onLogin={handleUserLogin} setCurrentPage={setCurrentPage} />),
    UserList: orgLoggedIn ? <UserList setCurrentPage={setCurrentPage} /> : <Home />,
    // UserForm: orgLoggedIn ? <UserForm setCurrentPage={setCurrentPage} /> : <Home />,
    UsersForm: orgLoggedIn ? <UsersForm setCurrentPage={setCurrentPage} /> : <Home />,
    Dashboard: <Dashboard setCurrentPage={setCurrentPage}/>,
    PRList: <PRList setCurrentPage={setCurrentPage}/>,
    VendorList: <VendorList setCurrentPage={setCurrentPage} />,
    VendorForm: <VendorForm setCurrentPage={setCurrentPage} />, 
    Report: <Report />,
    Solutions: <Solutions />,
    ContactUs: <ContactUs />,
    GSTInvoice: <GSTInvoice setCurrentPage={setCurrentPage}/>,
    Footer: <Footer/>
  };

  const renderContent = () => {
    return pageRoutes[currentPage] || <Home setCurrentPage={setCurrentPage} />;
  };

  return (
    <div className="app">
      {renderNavbar()}
      <div className="main">
        {renderSidebar()}
        <div className="content">{renderContent()}</div>
      </div>
    </div>
  );
}
export default App;